import { http } from '../../../common/http/client';
import { ResultData } from './resultData';

interface FundraisingSimulationData {
  president_age: number | null;
  birth_on: number | null;
  business_type: number | null;
  requested_funding_amount: number | null;
  total_funding_amount: number | null;
  current_valuation: number | null;
  previous_period_sales: number | null;
  financial_status: number | null;
}

interface FundraisingSimulationTag {
  ids: number[];
}

interface SimulateParams {
  type: string;
  fundraising_simulation: FundraisingSimulationData;
  fundraising_simulation_tag: FundraisingSimulationTag;
}

interface CreateParams {
  type: string;
  fundraising_simulation: FundraisingSimulationData;
  fundraising_simulation_tag: FundraisingSimulationTag;
}

export default class FundraisingSimulationClient {
  simulate(params: SimulateParams): Promise<ResultData> {
    return http.post<ResultData>('/api/v1/fundraising_simulation/simulate', {
      json: params,
    });
  }

  create(params: CreateParams): Promise<void> {
    return http.post<void>('/api/v1/fundraising_simulation', { json: params });
  }
}
